/** @jsx jsx */
import { useState } from 'react'
import { css, jsx } from '@emotion/core'
import { Button } from '@livechat/design-system'

const CopyButton = ({ text, textAfterCopy, copy }) => {
  const [buttonText, setButtonText] = useState(text)
  return (
    <Button
      onClick={() => {
        navigator.clipboard.writeText(copy)
        setButtonText(textAfterCopy)
        setTimeout(() => {
          setButtonText(text)
        }, 1000)
      }}
      size="compact"
      css={css`
        width: 120px;
        margin-left: auto;
        font-size: 14px;
        margin-top: 5px;
      `}
    >
      {buttonText}
    </Button>
  )
}

export default CopyButton
